import React, { Component } from 'react'
import LikeButton from '../buttons/LikeButton'
import RaisedButton from '../buttons/RaisedButton'
import { formatName, formatDate, Auth } from '../../../../helpers'
import './Question.css'
import Answer from './Answer'

export default class Question extends Component {
  constructor (props) {
    super(props)
    this.state = {
      activeLike: this.props.activeLike,
      viewAllAnswers: false
    }
  }

  componentWillReceiveProps (props, state) {
    if (props.activeLike !== this.state.activeLike) {
      this.setState({ activeLike: props.activeLike })
    }
  }

  addMoreStyles () {
    if (this.props.details.participant.avatar) {
      return {
        background: `url('${this.props.details.participant.avatar}')`,
        backgroundSize: '30px 30px'
      }
    }
    return {}
  }

  // addMoreAnswerStyles (answer) {
  //   if (answer.participant.avatar) {
  //     return {
  //       background: `url('${answer.participant.avatar}')`,
  //       backgroundSize: '50px 50px'
  //     }
  //   }
  //   return {}
  // }

  // renderAnswer (answer) {
  //   return (
  //     <div className='answer-wrap'>
  //       <div className='user-left-wrap' key='0'>
  //         <div className='user-image' style={this.addMoreAnswerStyles(answer)} />
  //       </div>
  //       <div className='body-right-wrap' key='1'>
  //         <div className='name-wrap'>
  //           <span>{formatName(answer.participant.name)} {answer.participant.handle}</span>
  //         </div>
  //         <div className='text-wrap'>
  //           <span> {answer.text.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)} </span>
  //         </div>
  //         <div className='buttons-wrap'>
  //           {Auth.isAdmin() && (
  //             <RaisedButton text='edit' onClick={() => {
  //               if (this.props.onAnswerEdit) {
  //                 this.props.onAnswerEdit(answer)
  //               }
  //             }} />
  //           )}
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }

  renderAnswers () {
    if (!this.props.answer) return null

    const adminAnswers = this.props.details.answer
    if (adminAnswers.length > 2 && !this.state.viewAllAnswers) {
      return [
        <div key='0' className='answer-wrap view-all-bttn-container'>
          <span
            onClick={() => this.setState({ viewAllAnswers: true })}
            className='view-answers-bttn'>[...] view all answers ({adminAnswers.length})</span>
        </div>,
        <Answer key='1' answer={adminAnswers[adminAnswers.length - 1]} onAnswerEdit={this.props.onAnswerEdit} />
      ]
    }
    return adminAnswers.map(a => <Answer key={a._id} answer={a} onAnswerEdit={this.props.onAnswerEdit} />)
  }

  likeText () {
    if (!this.props.details.likes) return '0 enjoys'
    if (this.props.details.likes.length === 1) {
      return '1 enjoy'
    }
    return `${this.props.details.likes.length} enjoys`
  }

  render () {
    return (
      <div className='question-all-wrap'>
        <div className={`question-wrap ${this.props.activeTab === 'ANSWERED' ? 'answered-q-wrap' : ''}`}>
          <div className='user-left-wrap'>
            <div className='user-image' style={this.addMoreStyles()} />
          </div>
          <div className='body-right-wrap'>
            <div className='name-wrap'>
              <span>{formatName(this.props.details.participant.name)} {this.props.details.participant.handle}</span>
              <span className='text-time'>{formatDate(this.props.details.createdAt)}</span>
            </div>
            <div className='text-wrap'>
              <span> {this.props.details.text.split('\n').map((item, key) => <span key={key}>{item}<br /></span>)} </span>
            </div>
            <div className='buttons-wrap'>
              <LikeButton text={this.likeText()} active={this.state.activeLike} onClick={() => {
                this.setState({ activeLike: !this.state.activeLike }, () => {
                  if (this.props.onLikeChange) {
                    this.props.onLikeChange.call(null, this.state.activeLike)
                  }
                })
              }} />
              <div style={{ display: 'flex' }}>
                {Auth.isAdmin() && (
                  <RaisedButton text='Answer' onClick={() => {
                    if (this.props.onAnswer) {
                      this.props.onAnswer.call(null)
                    }
                  }} />
                )}
                {!this.props.answer && this.props.details.participant._id === Auth.getParticipant() && (
                  <RaisedButton style={{ marginLeft: 10 }} text='edit' onClick={() => {
                    if (this.props.onEdit) {
                      this.props.onEdit.call(null)
                    }
                  }} />
                )}
              </div>
            </div>
          </div>
        </div>
        {this.renderAnswers()}
        {/* {this.props.details.answer &&
          this.props.details.answer.map(a => <Answer key={a._id} answer={a} onAnswerEdit={this.props.onAnswerEdit} />)} */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/comments/Question.js